import { CSSProperties, forwardRef, useState } from 'react';
import EyeIcon from '../../icons/Eye.icon';
import EyeOffIcon from '../../icons/EyeOff.icon';
import { Input, InputProps } from './Input';

export type SecretInputProps = Omit<InputProps, 'type' | 'endIcon'>;

// Masks via CSS text-security on a type="text" field so the browser's password
// manager never engages (no "Save password?" prompt) for API tokens/secrets.
// Use PasswordInput for actual account passwords where the manager IS wanted.
export const SecretInput = forwardRef<HTMLInputElement, SecretInputProps>(
  ({ style, ...props }, ref) => {
    const [reveal, setReveal] = useState(false);

    return (
      <Input
        {...props}
        ref={ref}
        type="text"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        data-lpignore="true"
        data-form-type="other"
        style={{ ...style, WebkitTextSecurity: reveal ? 'none' : 'disc' } as CSSProperties}
        endIcon={
          <button
            type="button"
            onClick={() => setReveal((prev) => !prev)}
            className="flex items-center justify-center text-muted-foreground transition-colors hover:text-foreground focus:outline-none"
            tabIndex={-1}
            aria-label={reveal ? 'Hide value' : 'Show value'}
          >
            {reveal ? <EyeOffIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
          </button>
        }
      />
    );
  },
);

SecretInput.displayName = 'SecretInput';
